export default class Components {

    constructor($){
        this.$ = $;
        this.currentBreakpoint;
    }
    init(index, element){
        
    }
    resize(index, element){
    }
    scroll(index, element){

    }
    breakpoint(index, element, breakpoint){
        this.currentBreakpoint = breakpoint;
    }
    

}
